import * as React from "react";
import Box from "@mui/material/Box";
import { useColorScheme } from "@mui/material/styles";
import { useLocation } from "react-router-dom";
import type { NavItemConfig } from "@/types/nav";
import type { DashboardNavColor } from "@/types/settings";
import { useNavigationList } from "../../../../api/navigation-hooks";
import { GeneralSideNavigation, DynamicDeviceSideNavigation, } from "../renderNavGroups";
import { navColorStyles } from "./styles";

export interface SideNavProps {
    color?: DashboardNavColor;
    items?: NavItemConfig[];
}

function getDeviceUuidFromPathname(pathname: string): string | undefined {
    return pathname.match(
        /^\/dashboard\/devices\/([^/]+)(?:\/|$)/
    )?.[1];
}

export function SideNav({ color = "evident", items = [], }: SideNavProps): React.JSX.Element {
    const { colorScheme = "light" } = useColorScheme();
    const styles = navColorStyles[colorScheme][color];

    const location = useLocation();

    const currentDeviceUuid = getDeviceUuidFromPathname(location.pathname);

    const {data: deviceNavigation} = useNavigationList(currentDeviceUuid);

    const isDeviceRoute = currentDeviceUuid !== undefined;

    return (
        <Box
            sx={{
                ...styles,
                bgcolor: "var(--SideNav-background)",
                borderRight: "var(--SideNav-border)",
                color: "var(--SideNav-color)",
                display: { xs: "none", lg: "flex" },
                flexDirection: "column",
                height: "100%",
                left: 0,
                position: "fixed",
                top: 0,
                width: 313,
                zIndex: "var(--SideNav-zIndex)",
            }}
        >
            {isDeviceRoute && deviceNavigation ? (
                    <DynamicDeviceSideNavigation
                        color={color}
                        isMobile={false}
                        navigation={deviceNavigation}
                        items={items}
                    />
            ) : (
                <GeneralSideNavigation
                    color={color}
                    isMobile={false}
                />
            )}
        </Box>
    );
}
